import { Routes } from '@angular/router';

import { PageNotFoundComponent } from './core/components/page-not-found.component'
import { AuthenticationRedirectGuard } from './security/services/AuthenticationRedirectGuard';
import { LandingPageComponent } from './core/components/landing-page.component';

export const appRoutes: Routes = [
  {
    path: 'public',
    component: LandingPageComponent,
    data: {
      skipGuard: true
    }
  },
  {
    path: '',
    component: PageNotFoundComponent,
    pathMatch: 'full',
    data: {
      skipGuard: true
    },
    canActivate: [AuthenticationRedirectGuard]
  },
  {
    path: '**',
    component: PageNotFoundComponent,
    data: {
      skipGuard: true
    }
  }
];



// WEBPACK FOOTER //
// ./src/app/routes.config.ts